import httpClient from '../httpClient';

const getRelatedLocations = (lat, lng) => {
  return httpClient.post('listing-locations/get-related-locations', {
    lat,
    lng,
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { getRelatedLocations };